import { render, staticRenderFns } from "./ProjectTask.vue?vue&type=template&id=650d42c0&scoped=true"
import script from "./ProjectTask.vue?vue&type=script&lang=js"
export * from "./ProjectTask.vue?vue&type=script&lang=js"
import style0 from "./ProjectTask.vue?vue&type=style&index=0&id=650d42c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650d42c0",
  null
  
)

export default component.exports